// Typelizer digest 0f9cdd54784dc72a8a49813e5a42777d
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../runtime'
import { buildUrl } from '../runtime'

export default {
  /** GET /c/:company_id/invoice_import */
  show: (options?: RouteOptions): RouteDefinition<'get'> => ({
    url: buildUrl('/c/:company_id/invoice_import', {}, options),
    method: 'get',
  }),

  /** POST /c/:company_id/invoice_import */
  create: (options?: RouteOptions): RouteDefinition<'post'> => ({
    url: buildUrl('/c/:company_id/invoice_import', {}, options),
    method: 'post',
  }),
}
